import React from 'react';
import { Button } from 'semantic-ui-react';
import { useAuth } from '../../routes/components/AuthProvider';
import { useTranslation } from 'react-i18next';

interface AzureSSOButtonProps {
  className?: string;
  size?: 'mini' | 'tiny' | 'small' | 'medium' | 'large' | 'big' | 'huge' | 'massive';
  fluid?: boolean;
  disabled?: boolean;
}

const AzureSSOButton: React.FC<AzureSSOButtonProps> = ({
  className = '',
  size = 'medium',
  fluid = false,
  disabled = false
}) => {
  const { loginWithAzure } = useAuth();
  const { t } = useTranslation();

  const handleAzureLogin = async () => {
    try {
      await loginWithAzure();
    } catch (error) {
      console.error('Azure login failed:', error);
    }
  };

  return (
    <Button
      className={`azure-sso-button ${className}`}
      size={size}
      type='button'
      fluid={fluid}
      style={{ margin: 0 }}
      disabled={disabled}
      onClick={handleAzureLogin}
      icon='microsoft'
      content={t('Sign in with Microsoft')}
      color='blue'
    />
  );
};

export default AzureSSOButton;
